import React, { useState, useEffect } from 'react';

const Masthead = () => {
   const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

   useEffect(() => {
      const handleMouseMove = (e) => {
         setMousePosition({ x: e.clientX, y: e.clientY });
      };

      const handleResize = () => {
         setIsMobile(window.innerWidth < 768);
      };

      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('resize', handleResize);

      return () => {
         window.removeEventListener('mousemove', handleMouseMove);
         window.removeEventListener('resize', handleResize);
      };
   }, []);

   const calculateMove = (element, moveFactor) => {
      // Désactiver l'effet de parallaxe sur mobile pour de meilleures performances
      if (isMobile) return { transform: 'none' };

      const moveX = (mousePosition.x / window.innerWidth - 0.5) * moveFactor;
      const moveY = (mousePosition.y / window.innerHeight - 0.5) * moveFactor;
      return { transform: `translate(${moveX}px, ${moveY}px)` };
   };

   return (
      <section className="relative pt-12 md:pt-16 lg:pt-24 overflow-hidden">
         {/* Background */}
         <div className="absolute inset-0 z-0 pr-4 md:pr-16 lg:pr-0">
            <img
               src="/home-6/hero/bg.png"
               alt="background"
               className="w-full h-full object-cover"
            />
         </div>

         <div className="container mx-auto px-4 relative z-10">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-16 items-center justify-between">
               {/* Content Section */}
               <div className="w-full lg:w-1/2 order-2 lg:order-1">
                  <div className="max-w-lg mx-auto lg:mx-0">
                     <h1 className="text-3xl md:text-4xl italic text-dark-1 font-bold leading-tight mb-4 md:mb-6 text-center lg:text-left">
                        Passez au niveau <span className="text-purple-1 underline">supérieur</span><br className="hidden md:block" />
                        avec l'accompagnement de <br className="hidden md:block" />
                        tuteurs internationaux
                     </h1>

                     <div className="flex flex-col sm:flex-row gap-4 md:gap-6 items-center pt-6 md:pt-8 justify-center lg:justify-start">
                        <a
                           href="https://app.gonextmaker.com/auth/signup"
                           className="bg-dark-1 hover:bg-transparent text-white hover:text-dark-1 font-medium rounded-full px-8 md:px-14 py-3 md:py-4
                  transition-colors border-2 border-dark-1 text-center w-full sm:w-auto"
                        >
                           Commencer maintenant
                        </a>

                        <a
                           href="https://www.youtube.com/watch?v=ANYfx4-jyqY"
                           className="flex items-center text-dark-1 hover:text-purple-1 transition-colors justify-center sm:justify-start mt-4 sm:mt-0"
                        >
                           <div className="flex justify-center items-center w-12 h-12 md:w-16 md:h-16 rounded-full border-2 border-dark-1">
                              <span className="text-xl ml-1 text-dark-1">▶</span>
                           </div>
                           <div className="ml-3 md:ml-4 font-medium">Watch Video</div>
                        </a>
                     </div>

                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 pt-12 md:pt-16 lg:pt-12">
                        <div className="flex items-center justify-center lg:justify-start">
                           <div className="mr-3 md:mr-4">
                              <img src="/home-6/hero/icons/1.svg" alt="students icon" className="w-8 h-8 md:w-10 md:h-10" />
                           </div>
                           <div className="font-medium text-sm md:text-base">Over 12 million students</div>
                        </div>

                        <div className="flex items-center justify-center lg:justify-start">
                           <div className="mr-3 md:mr-4">
                              <img src="/home-6/hero/icons/2.svg" alt="courses icon" className="w-8 h-8 md:w-10 md:h-10" />
                           </div>
                           <div className="font-medium text-sm md:text-base">More than 60,000 courses</div>
                        </div>

                        <div className="flex items-center justify-center lg:justify-start">
                           <div className="mr-3 md:mr-4">
                              <img src="/home-6/hero/icons/3.svg" alt="online learning icon" className="w-8 h-8 md:w-10 md:h-10" />
                           </div>
                           <div className="font-medium text-sm md:text-base">Learn anything online</div>
                        </div>
                     </div>
                  </div>
               </div>

               {/* Image Composition Section */}
               <div className="w-full lg:w-1/2 relative order-1 lg:order-2 mb-8 lg:mb-0">
                  <div className="relative w-full max-w-xl mx-auto">
                     {/* Main Images */}
                     <div className="relative grid grid-cols-1 md:grid-cols-2 items-center md:h-[500px] lg:h-[600px] gap-4 md:gap-6">
                        {/* Colonne gauche */}
                        <div className="flex flex-col gap-y-12 md:gap-y-20 h-full">
                           {/* Carte 1 (haut) */}
                           <div className="flex items-center justify-center rounded-2xl w-full h-[180px] md:h-[220px] relative">
                              <img
                                 src="/home-6/hero/2.png"
                                 alt="education"
                                 className="w-full h-full object-contain relative z-10"
                                 style={calculateMove(40, 40)}
                              />
                           </div>

                           {/* Carte 2 (bas) */}
                           <div className="flex items-center justify-end rounded-2xl w-full h-[160px] md:h-[200px] relative">
                              <img
                                 src="/home-6/hero/3.png"
                                 alt="education"
                                 className="w-full h-full object-contain relative z-30"
                                 style={calculateMove(40, 40)}
                              />
                           </div>
                        </div>

                        {/* Colonne droite */}
                        <div className="flex items-end justify-center h-full relative" style={{ height: "480px" }}>
                           <img
                              src="/home-6/hero/1.png"
                              alt="education"
                              className="w-full max-w-[90%] h-[420px] md:h-[520px] object-contain z-20"
                              style={calculateMove(40, 40)}
                           />
                        </div>
                     </div>

                     {/* Floating Elements - Masqués sur mobile pour plus de clarté */}
                     {!isMobile && (
                        <>
                           <div
                              className="absolute top-16 right-28 md:block bg-white p-5
                              rounded-lg shadow-lg flex items-center z-40 h-[90px] w-[200px]"
                              style={calculateMove(30, 30)}
                           >
                              <div className='flex'>
                                 <div className="w-12 h-12 flex justify-center items-center bg-red-100 rounded-full">
                                    <img src="/masthead/1.svg" alt="free courses" className="w-6 h-6" />
                                 </div>
                                 <div className="ml-5">
                                    <div className="text-orange-500 font-medium">3.000 +</div>
                                    <div className="text-sm mt-1 text-dark-1">Free Courses</div>
                                 </div>
                              </div>
                           </div>

                           <div className="absolute top-48 -left-32 z-40 hidden lg:block">
                              <div className="bg-white p-5 w-[290px] h-[90px] rounded-xl flex items-center">
                                 <div className="bg-purple-1 p-3 rounded-full">
                                    <img
                                       src="/masthead/2.svg"
                                       alt="Admission"
                                       className="w-6 h-6"
                                    />
                                 </div>
                                 <div className="ml-4">
                                    <div className="text-purple-1">Félicitations !</div>
                                    <div className="text-gray-600 dark:text-gray-400 text-sm">Votre admission complétée</div>
                                 </div>
                              </div>
                           </div>

                           <div className="absolute bottom-8 -left-20 z-40 hidden lg:block">
                              <div className="bg-white p-5 w-[290px] h-[90px] rounded-xl flex items-center">
                                 <img
                                    src="/masthead/4.png"
                                    alt="Ali Tufan"
                                    className="w-12 h-12 rounded-full"
                                 />
                                 <div className="ml-4">
                                    <div className="text-dark-1">Ali Tufan</div>
                                    <div className="text-gray-600 dark:text-gray-400 text-sm">Mentor</div>
                                    <div className="flex mt-1">
                                       {[...Array(5)].map((_, i) => (
                                          <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                                             <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                          </svg>
                                       ))}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default Masthead;